import { render, staticRenderFns } from "./ProjectElement.vue?vue&type=template&id=9f7ccb50&scoped=true"
import script from "./ProjectElement.vue?vue&type=script&lang=js"
export * from "./ProjectElement.vue?vue&type=script&lang=js"
import style0 from "./ProjectElement.vue?vue&type=style&index=0&id=9f7ccb50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ccb50",
  null
  
)

export default component.exports